var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.cssVars)},[(_vm.showNav)?_c('Navigation'):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }